import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Login from '../views/Login';
import Utilizatori from '../views/Utilizatori';
import TreatmentPlanPDF from '../views/TreatmentPlanPDF.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/utilizatori',
    meta: {
      auth: true,
      role: 'admin'
    },
    name: 'utilizatori',
    component: Utilizatori
  },
  {
    path: '/plan-tratament/:id',
    name: 'plan-tratament-pdf',
    component: TreatmentPlanPDF
  },
  {
    path: '/pacienti',
    meta: {
      auth: true
    },
    component: () => import('../views/PacientiLayout.vue'),
    children: [
      {
        path: '',
        meta: {
          auth: true
        },
        component: () => import('../views/ListaPacienti.vue')
      },
      {
        path: 'history/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'history',
        component: () => import('../views/HistoryPacient.vue')
      },
      {
        path: 'planuri-tratament/new/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'create-plan-tratament',
        component: () => import('../views/NewTreatmentPlan.vue')
      },
      {
        path: 'plan-tratament/edit/:idPlanTratament/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'edit-plan-tratament',
        component: () => import('../views/NewTreatmentPlan.vue')
      },
      {
        path: 'planuri-tratament/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'planuri-tratament',
        component: () => import('../views/PlanuriTratament.vue')
      },
      {
        path: 'plan-tratament/:idPlanTratament/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'plan-tratament',
        component: () => import('../views/PlanTratamentPreview.vue')
      },
      {
        path: 'list',
        meta: {
          auth: true
        },
        name: 'list-pacients',
        component: () => import('../views/ListaPacienti.vue')
      },
      {
        path: 'add',
        meta: {
          auth: true
        },
        name: 'add-patient',
        component: () => import('../views/AddPacient.vue')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'edit',
        component: () => import('../views/AddPacient.vue')
      },
      {
        path: 'programari/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'programari',
        component: () => import('../views/Programari.vue')
      },
      {
        path: 'docs/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'docs',
        component: () => import('../views/DocsHistory.vue')
      },
      {
        path: 'schita/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'schita',
        component: () => import('../views/SchitaDentara.vue')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    store.state.isLogged ? next('/pacienti') : next();
  } else {
    to.meta.auth && !store.state.isLogged
      ? store.dispatch('checkLogin', { to, next })
      : next();
  }
});

export default router;
